import { useNavigate } from "@tanstack/react-router";
import { useIntl } from "react-intl";

import { Tab, Tabs } from "@/components/Tabs";
import {
  FlightSearchTrackingEvents,
  HomeTrackingEvents,
  HotelSearchTrackingEvents,
  rudderAnalytics,
} from "@/lib/rudderstack";

type SearchCategorySwitcherProps = {
  current: "flights" | "hotels";
};

export const SearchCategorySwitcher = ({
  current,
}: SearchCategorySwitcherProps) => {
  const intl = useIntl();
  const navigate = useNavigate();

  return (
    <Tabs
      value={current}
      onChange={(newCategory) => {
        if (newCategory === "flights") {
          rudderAnalytics.track(HomeTrackingEvents.USER_CLICKED_HOME_SERVICE, {
            service: "flight",
          });
          rudderAnalytics.track(
            FlightSearchTrackingEvents.USER_SWITCHED_TO_FLIGHT_SEARCH,
          );

          navigate({
            to: "/flights/search",
            replace: true,
          });

          return;
        }

        rudderAnalytics.track(HomeTrackingEvents.USER_CLICKED_HOME_SERVICE, {
          service: "hotel",
        });
        rudderAnalytics.track(
          HotelSearchTrackingEvents.USER_SWITCHED_TO_HOTEL_SEARCH,
        );

        navigate({
          to: "/hotels/search",
          replace: true,
        });
      }}
    >
      <Tab
        value="flights"
        label={intl.formatMessage({
          description: "Navigation label for the Flights section",
          defaultMessage: "Flights",
        })}
      />
      <Tab
        value="hotels"
        label={intl.formatMessage({
          description: "Navigation label for the Hotels section",
          defaultMessage: "Hotels",
        })}
      />
    </Tabs>
  );
};
